import { runGateCore, type GateOptions, type GateResult } from "./securityGateCore";
import type { WorkerReq, WorkerRes } from "./securityGate.worker";

export async function militaryGradeClientGateAgainstSuspiciousOrSeditiousFiles(
  file: File,
  options?: GateOptions,
): Promise<GateResult> {
  // Try worker; on any failure or timeout, fall back to main thread.
  try {
    if (typeof window !== "undefined" && typeof Worker !== "undefined") {
      const worker = new Worker(new URL("./securityGate.worker.ts", import.meta.url), {
        type: "module",
      });

      const res: GateResult = await new Promise((resolve) => {
        const timer = setTimeout(() => {
          worker.terminate();
          resolve({ ok: false, reason: "worker_timeout", message: "Validation timed out." });
        }, (options?.timeoutMs ?? 6000) + 500);

        worker.onmessage = (e: MessageEvent<WorkerRes>) => {
          clearTimeout(timer);
          worker.terminate();
          resolve(e.data);
        };
        worker.onerror = () => {
          clearTimeout(timer);
          worker.terminate();
          resolve({ ok: false, reason: "worker_error", message: "Worker error." });
        };

        const req: WorkerReq = { file, options };
        worker.postMessage(req);
      });

      // ✅ Narrow before accessing `reason`
      if (
        !res.ok &&
        "reason" in res &&
        (res.reason === "worker_timeout" || res.reason === "worker_error")
      ) {
        return await runGateCore(file, options);
      }
      return res;
    }
  } catch (err) {
    console.warn("[securityGate] worker unavailable, validating on the main thread:", err);
  }
  return await runGateCore(file, options);
}
